import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { getLogLabel } from './logUtils';

type LogFilterSelectProps = {
    value: string;
    options: string[];
    allLabel: string;
    onChange: (value: string) => void;
};

export default function LogFilterSelect({ value, options, allLabel, onChange }: LogFilterSelectProps) {
    return (
        <Select
            className="activity-log__select"
            size="small"
            displayEmpty
            value={value}
            onChange={(e) => onChange(e.target.value as string)}
            MenuProps={{ PaperProps: { className: 'activity-log__menu' } }}
        >
            <MenuItem value="">{allLabel}</MenuItem>
            {options.map((option) => (
                <MenuItem key={option} value={option}>{getLogLabel(option)}</MenuItem>
            ))}
        </Select>
    );
}
